import { ReactComponent as ArrowRight } from "assets/icons/arrow-right-long.svg";
import { useTranslation } from "react-i18next";

const Header = () => {
  const { t } = useTranslation();
  return (
    <div className="mt-5 mx-5 px-4 h-20 bank-pattern overflow-hidden relative rounded-lg flex items-center justify-between sm:justify-center">
      <img
        src={"https://cdn.firouzeh.com/public/bank-card-id-back.png"}
        className="self-end max-w-44"
        alt="Bank Card"
      />
      <ArrowRight className="w-6 sm:mx-3" />
      <span className="body-14px-regular text-gray-4">
        {t("card-page.id-card")}
      </span>
    </div>
  );
};
export default Header;
